import { checkIsClientSide } from '@packages/shared/core/common/utils/checkIsClientSide';

export const useRedirectTo = () => {
  const redirectTo = (path: string) => {
    if (!checkIsClientSide()) return;

    window.location.assign(path);
  };

  return { redirectTo };
};
